import React, { Component } from 'react';
import { func } from 'prop-types';

// Page styles
import s from './ForgotUsernameDialog.css';

/**
 * Article for Assumptions & Patterns:
 *  https://engineering.musefind.com/our-best-practices-for-writing-react-components-dec3eb5c3fc8
 *
 * setState() is asynchronous because react batches changes
 * for performance reasons. The state may not change immediately
 * after calling setState(), which means you should not rely on
 * the current state when calling setState, but rather pass a callback
 * function.
 */
export default class ForgotUsernameDialog extends Component {
  state = {
    value: undefined,
  };

  static propTypes = {
    closeConfirmDialog: func,
    openConfirmDialog: func,
    handleForgotUsername: func,
    hideFullPageLoadingState: func,
    showFullPageLoadingState: func,
  };

  /**
   * Handle the text field input by updating the state each time
   * the input changes.
   *
   * WARNING: The synthetic event is reused for performance reasons.
   * The property `target` could be released/nullified on a
   * synthetic event. Therefore, set it to a constant and release it.
   */
  handleChange = (event) => {
    const value = event.target.value;

    this.setState(prevState => ({ value }));
  };

  onClickHandler = () =>
    this.props.openConfirmDialog({
      title: 'Forgot Username',
      cancelCallback: () => {
        this.setState(prevState => ({ value: undefined }));
        this.props.closeConfirmDialog()
      },
      cancelLabel: 'Cancel',
      okCallback: this.submit,
      okLabel: 'Send',
      content:
        <div>
          <p className={s.helpText}>
            Please enter the email associated with your account.
          </p>
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="forgotUsernameDialogInput">
              Email
            </label>
            <input
              id="forgotUsernameDialogInput"
              name="email"
              type="email"
              className={s.control}
              onChange={this.handleChange}
              required
              value={this.state.value}
            />
          </div>
        </div>
      });

  /**
   * Forgot Username API call with no operation. Send the request
   * and carry on with your day.
   */
  submit = () => {
    const email = this.state.value;

    // Fail silently
    if (email === undefined) {
      this.props.closeConfirmDialog();
      return false;
    }
    // Success and error callbacks are the same - hideFullPageLoadingState
    const callback = () => {
      this.setState(prevState => ({ value: undefined }));
      this.props.hideFullPageLoadingState();
    };

    this.props.showFullPageLoadingState();

    this.props.handleForgotUsername(email, callback, callback);

    this.props.closeConfirmDialog();
  };

  render = () =>
    <a
      className={s.cta}
      onClick={this.onClickHandler}
    >
      Forgot username?
    </a>;
}



// WEBPACK FOOTER //
// ./src/components/Pages/Login/ForgotUsernameDialog/ForgotUsernameDialog.js